import { useAppStore } from '@/lib/store'

/**
 * `true` when the user prefers reduced motion (OS setting) or `?motion=reduced` is set.
 * It re-renders when the OS setting changes.
 *
 * Under reduced motion: no scrubbed transforms or autoplay loops, content fades in over
 * about 0.3s, and 3D renders a single still composition.
 * Outside React, read `useAppStore.getState().reducedMotion`.
 */
export function useReducedMotion(): boolean {
  return useAppStore((state) => state.reducedMotion)
}
